;
define("pickup_in_store_store_selector_item_detail.tpl", function(){});

